export const iconFontAwesomeUsersPeopleUserNinja = (
	<i className="fa-solid fa-user-ninja"></i>
);
